import React from "react"

import { Helmet } from "react-helmet-async"

import { UtilHelper } from "../helpers/util.helper"

export const PageHelmetElement: React.FunctionComponent<
    IPageHelmetElementProps
> = props => {
    return (
        <Helmet>
            <title>
                {props.title ? `${props.title} - ` : ""}
                {props.defaultPageTitle}
            </title>

            {!props.ignoreCanonicalTag && (
                <link
                    rel="canonical"
                    href={props.canonicalUrl || UtilHelper.getCurrentUrl()}
                />
            )}

            {props.children}
        </Helmet>
    )
}

interface IPageHelmetElementProps {
    children?: React.ReactNode
    title?: string
    defaultPageTitle: string
    ignoreCanonicalTag?: boolean
    canonicalUrl?: string
}
